import Image from '@atlaskit/image';
import { Box, Inline } from '@atlaskit/primitives';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const Home = () => {
    const history = useHistory();

    useEffect(() => {
        // Wait for 3 seconds before redirecting to the first onboarding step
        const timer = setTimeout(() => {
            history.push('/slack/onboard/welcome');
        }, 3000);

        return () => clearTimeout(timer);
    }, [history]);

    return (
        <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '50px' }}>
            <Inline alignBlock="center" alignInline="center">
                <Image width={600} height={600} src={"https://images.ctfassets.net/8j5aqoy0ts8s/bl1kDwq4k1lpEIy9tSl1l/562b753cabb00323931748bf4da079c8/hero.png"} alt="Fetching your subscription details" testId="image" />
            </Inline>
            <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Fetching your details…
            </Box>
        </Box>
    );
};